
(function ($) {
    $.extend({
        /**
         * @description This jquery plugin handle ajax requests. As default content type and data type is for json requests
         * @example $.ajaxHandler({
         *               "data" 				: <data>,
         *               "url" 				    : <url>",
         *               "callback_success" 	: <callback function name for success>
         *          });
         * 
         *          See settings for more possible parameter
         * 
         *          Response: Definition of return values is a json with the key success. This key must have a boolean value
         *          and controls the callback methods for successful and error inside the success handler.
         *          
         *          The key result contains the data for callback function
         *  
         *          { 
         *              "success"   : boolean,
         *              "result"    : {} 
         *          }
         *          
         * @returns mixed 
         */
        ajaxHandler: function (options) {
            
            var settings = $.extend({
                // mandotary values
                url                 : "",
                data                : "",
                // optional values
                type                : 'POST',
                dataType            : 'json',
                contentType         : 'application/json',
                cache               : false,
                async               : true,
                // callback functions
                callback_success    : "",
                callback_error      : "",
            }, options );

            if(checkMandatoryParameters()){
                
                // Stringify data if data type == json
                if(settings.dataType == "json"){
                    settings.data = JSON.stringify(settings.data);    
                }
                
                // Call ajax function
                return ajaxRequest();
            }
            
            /**
             * @description This function checks the mandotary values there need for ajax request
             * 
             * @returns boolean
             */
            function checkMandatoryParameters(){
                
                // Check mandotary Values
                if(!settings.url){
                    return false;
                }

                if(!settings.data){
                    return false
                }

                return true;
            }
            
            /**
             * @description This function start the ajax request and handle the callbacks
             * 
             * @callback injected function name 
             * @returns mixed (boolean | data) 
             */
            function ajaxRequest(){

                var synchronousResult = "";

                $.ajax({
                    type:           settings.type,
                    contentType:    settings.contentType,
                    dataType:       settings.dataType,
                    url:            settings.url,
                    data:           settings.data,
                    cache:          settings.cache,
                    async:          settings.async,

                    // success handler
                    success: function(data){

                        if(!settings.async){
                            synchronousResult = data;
                        }

                        // check if return value for success == true 
                        if(data.success){
                            // Check if success callback function exist and call it
                            if(settings.callback_success && typeof window[settings.callback_success] === "function"){
                                window[settings.callback_success](data);
                            }else{
                                return data;
                            }
                            return true;
                        }

                        // check if return value for success == false 
                        if(!data.success){
                            // Check if error callback function exist and call it
                            if(settings.callback_error && typeof window[settings.callback_error] === "function"){
                                window[settings.callback_error](data);
                            }else{
                                return false;
                            }
                        }

                        return false;
                    },

                    // error handler eg. url not found 
                    error: function(data){
                        // Check if error callback function exist and call it
                        if(settings.callback_error && typeof window[settings.callback_error] === "function"){
                            window[settings.callback_error](data);
                        }else{
                            return false;
                        }
                    }    
                });

                return synchronousResult;
            }
        }
    });
})(jQuery);


    